﻿/* 
Object:         User Profile
Description:    Logic and events for the module User Profile
Used in:        UserProfile
*/


window.userprofile = function () {

    return {
        /**
        * Init (binding button actions)
        */
        initialize: function () {


        },

        /**
        * logout
        */
        logout: function () {
            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("Account/Logout"),
                success: function (responseData) {
                    window.location.assign(appsettings.getLocalUrl("Account/Login"));
                }
            });
        }

    }

}();